import type { Space } from '@/types';
import { SpacesIcon } from '@/components/icons';

interface SpacesSectionProps {
  spaces: Space[];
  onAdd?: () => void;
}

export function SpacesSection({ spaces, onAdd }: SpacesSectionProps) {
  return (
    <div className="sidebar__section">
      <div className="sidebar__section-header">
        <span className="sidebar__section-label">Spaces</span>
        <button className="sidebar__section-add" onClick={onAdd} aria-label="Add space">+</button>
      </div>

      {spaces.length === 0 ? (
        <div className="sidebar__empty-state">
          <div className="sidebar__empty-title-row">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              focusable="false"
            >
              <path
                d="M8.2 12.7 5.43 15.5c-.386.391-.58.586-.745.6a.41.41 0 0 1-.378-.153c-.108-.127-.108-.401-.108-.95V12.7c-.464 0-.697 0-.891-.029A1.95 1.95 0 0 1 1.028 10.39C1 10.197 1 9.964 1 9.5V5.32c0-1.512 0-2.268.294-2.846A2.7 2.7 0 0 1 2.474 1.294C3.052 1 3.808 1 5.32 1h6.66c1.512 0 2.268 0 2.846.294a2.7 2.7 0 0 1 1.18 1.18c.294.578.294 1.334.294 2.846V9.1m0 9.9-1.96-1.362c-.275-.191-.413-.287-.563-.355a1.485 1.485 0 0 0-.416-.13c-.162-.03-.33-.03-.665-.03H11.08c-1.008 0-1.512 0-1.897-.196a1.74 1.74 0 0 1-.787-.787C8.2 15.755 8.2 15.25 8.2 14.243v-2.263c0-1.008 0-1.512.196-1.897a1.74 1.74 0 0 1 .787-.787c.385-.196.89-.196 1.897-.196h5.04c1.008 0 1.512 0 1.897.196.339.173.614.448.787.787.196.385.196.89.196 1.897v2.443c0 .838 0 1.258-.137 1.589-.183.441-.533.791-.974.974-.33.137-.75.137-1.589.137V19Z"
                stroke="#7C7C67"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span className="sidebar__empty-title">No Spaces yet</span>
          </div>
          <p className="sidebar__empty-desc">Create a space to group related conversations</p>
        </div>
      ) : (
        <ul className="sidebar__list">
          {spaces.map((space) => (
            <li key={space.id} className="sidebar__space-item">
              <SpacesIcon size={14} />
              <span>{space.name}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
